<script>
import Component, { mixins } from 'vue-class-component';
import WebPanelMixin from '@/core/shared/web-panel/WebPanelMixin';
import { mapGetters } from 'vuex';
import ContentOwnershipValidatorHelper from './content-ownership/ContentOwnershipValidatorHelper';
import '@/core/shared/helpers/ValidationHelper';

@Component({
  computed: mapGetters([
    'currentOrganization',
  ]),
})
export default class App extends mixins(WebPanelMixin) {
  topLink = { name: 'home' };
  get contentOwnerships () {
    return this.$store.getters['entities/ContentOwnership/all']();
  }

  get navigation () {
    const numberOfContentOwnershipsNeedingUpdate = this.contentOwnerships.filter(contentOwnership => {
      return !ContentOwnershipValidatorHelper.valid(contentOwnership);
    }).length;

    return [
      {
        name: this.$t('Analytics'),
        icon: 'icon-bar-chart-2',
        routerLink: { name: 'analytics' },
      },
      {
        name: this.$t('Content'),
        icon: 'icon-layers',
        routerLink: { name: 'content-ownerships' },
        notification: numberOfContentOwnershipsNeedingUpdate,
      },
      {
        name: this.$t('Bundles'),
        icon: 'icon-layers',
        routerLink: { name: 'bundles' },
      },
      {
        name: this.$t('Admin'),
        icon: 'icon-sliders',
        routerLink: { name: 'admin' },
        children: [
          {
            name: this.$t('Organization Details'),
            routerLink: { name: 'organization-details' },
          },
          ...((!this.$permissions['enterprise-developer'])
            ? [
              {
                name: this.$t('Monthly Statements'),
                routerLink: { name: 'monthly-statements' },
              },
            ]
            : []
          ),
        ],
      },
    ];
  }

  get globalMessages () {
    if (!this.currentOrganization) return [];
    const messages = [];
    if (!this.currentOrganization.taxForm) {
      // if (!this.$route.name?.includes('sign-up')) {
      //   messages.push({
      //     message: this.$t('Remember to fill your tax form, you won’t be able to publish any title'),
      //     background: 'yellow-gradient',
      //     buttonText: 'Upload Your Tax Form',
      //     action: ['goToTaxForm'],
      //   });
      // }
    } else {
      if (!this.currentOrganization.financeEmail) {
        // messages.push({
        //   message: this.$t('Remember to fill in your contact details'),
        //   background: 'yellow-gradient',
        //   buttonText: 'Open Organization Details',
        //   action: ['goToOrganizationDetails'],
        // });
      }
      const isTaxFormPending = this.currentOrganization.taxForm.status !== 'approved';
      const pendingContentOwnerships = [];
      const rejectedContentOwnerships = [];
      const missingEULAContentOwnerships = [];
      const transitioningToCDSContentOwnerships = [];
      let shouldShowTaxBanner = true;
      if (this.contentOwnerships && this.contentOwnerships.length) {
        for (const contentOwnership of this.contentOwnerships) {
          const { cds, approvalStatus, currentAgreement, status } = contentOwnership;
          if (cds && !currentAgreement && approvalStatus === 'approved' && status === 'active') {
            missingEULAContentOwnerships.push(contentOwnership);
          } else if (cds && approvalStatus === 'pending' && status !== 'active') {
            pendingContentOwnerships.push(contentOwnership);
          } else if (cds && approvalStatus === 'pending' && status === 'active') {
            transitioningToCDSContentOwnerships.push(contentOwnership);
          } else if (cds && approvalStatus === 'rejected') {
            rejectedContentOwnerships.push(contentOwnership);
          }
        }
      }
      if (pendingContentOwnerships.length) {
        const titleNames = pendingContentOwnerships.map(({ title }) => title).join(', ');
        if (!isTaxFormPending) {
          messages.push({
            message: this.$t('We are reviewing {titlename}. When it’s approved, you will receive an email and will be able to publish your content.', { titlename: titleNames }),
            background: 'yellow-gradient',
          });
        } else {
          messages.push({
            message: this.$t('We are reviewing your tax form and {titlename}. When they are approved, you will receive an email and will be able to publish your content.', { titlename: titleNames }),
            background: 'yellow-gradient',
          });
          shouldShowTaxBanner = false;
        }
      }
      if (rejectedContentOwnerships.length) {
        const titleNames = rejectedContentOwnerships.map(({ title }) => title).join(', ');
        if (!isTaxFormPending) {
          messages.push({
            message: this.$t('{titlename} was rejected, please check your email for details.', { titlename: titleNames }),
            background: 'yellow-gradient',
          });
        } else {
          messages.push({
            message: this.$t('{titlename} was rejected, please check your email for details. We are reviewing your tax form. When they are approved, you will receive an email and will be able to publish your content.', { titlename: titleNames }),
            background: 'yellow-gradient',
          });
          shouldShowTaxBanner = false;
        }
      }
      if (!this.$permissions['enterprise-developer'] && missingEULAContentOwnerships.length) {
        const titleNames = missingEULAContentOwnerships.map(({ title }) => title).join(', ');
        messages.push({
          message: this.$t('A EULA must be added to publish {titlename}.', { titlename: titleNames }),
          background: 'yellow-gradient',
        });
      }
      if (transitioningToCDSContentOwnerships.length) {
        const titleNames = transitioningToCDSContentOwnerships.map(({ title }) => title).join(', ');
        const singleMsg = this.$t('To get published, it needs to be approved and have a EULA.');
        const pluralMsg = this.$t('To get published, they need to be approved and have a EULA.');
        messages.push({
          message: `${this.$t('We are reviewing {titlename}.', { titlename: titleNames })} ${titleNames.length === 1 ? singleMsg : pluralMsg}`,
          background: 'yellow-gradient',
        });
      }
      if (isTaxFormPending && shouldShowTaxBanner) {
        messages.push({
          message: this.$t('We are reviewing your tax form. When it\'s approved, you will receive an email and will be able to publish your content.'),
          background: 'yellow-gradient',
        });
      }
    }
    return messages;
  }
};
</script>

<style lang="postcss">
@import "styles/static";
</style>
